/**
 * @generated SignedSource<<0fbca1bfde202c46da525de546d09523>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FiatWalletViewQuery$variables = Record<PropertyKey, never>;
export type FiatWalletViewQuery$data = {
  readonly fiatWallet: {
    readonly balance: PrecisionFloat;
    readonly fiat: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly symbol: string | null | undefined;
    };
  } | null | undefined;
};
export type FiatWalletViewQuery = {
  response: FiatWalletViewQuery$data;
  variables: FiatWalletViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FiatWallet",
    "kind": "LinkedField",
    "name": "fiatWallet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "balance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Fiat",
        "kind": "LinkedField",
        "name": "fiat",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "symbol",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FiatWalletViewQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FiatWalletViewQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "38ebc01b00b20704514b6decc0c0ea00",
    "id": null,
    "metadata": {},
    "name": "FiatWalletViewQuery",
    "operationKind": "query",
    "text": "query FiatWalletViewQuery {\n  fiatWallet {\n    balance\n    fiat {\n      id\n      name\n      symbol\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1e914e22da52a65d9ac46cff3ae4502c";

export default node;
